import 'css-chunksrc/client/scenes/planzoneResourceRemoval/infoUser/styles.scss';export default {
  "dataUser": "_dataUser_l17dt_1",
  "profession": "_profession_l17dt_8",
  "avatar": "_avatar_l17dt_14",
  "resourceBox": "_resourceBox_l17dt_24",
  "name": "_name_l17dt_30"
};